import { render, staticRenderFns } from "./DevelopmentPage.vue?vue&type=template&id=cd64ac6e"
import script from "./DevelopmentPage.vue?vue&type=script&lang=js"
export * from "./DevelopmentPage.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentPage.vue?vue&type=style&index=0&id=cd64ac6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports